import React, { useState, useEffect } from "react";
import { ReactComponent as Spinner } from "../../../assets/spinner.svg";
import styles from "./RegisterSytemUserForm.module.css";
import firebase, { useCollection } from "../../../app/config/firebase";
import { toastr } from "react-redux-toastr";


const EditSystemUserForm = ({
  user = {},
  onSubmit,
  loading,
  error,
}) => {
  const [formValues, setFormValues] = useState({
    firstName: user.firstName || "",
    lastName: user.lastName || "",
    role: user.role || "",
    branch: user.branch || ""
  });

  const [errors, setErrors] = useState({});


  const [userRoles, setUserRoles] = useState([]);

  const branches = useCollection("branches", "branch");
  const fetchUserRoles = async () => {
    try {
      const snapshot = await firebase
        .firestore()
        .collection("userRoles")
        .where("roleScope", "==", "PrepaidPlus")
        .get();
    
      const rolesArray = snapshot.docs.map((doc) => doc.data());
      setUserRoles(rolesArray);
    } catch (error) {
      console.error("Error fetching user roles:", error);
    }
  };


  useEffect(() => {


    fetchUserRoles();
  }, []);

  useEffect(() => {
    
    const currentUserRole = user.role || "";
    const currentBranch = user.branch || "";
    if (
      currentUserRole &&
      !userRoles.some((role) => role.role === currentUserRole)
    ) {
      setUserRoles((prevRoles) => [
        { role: currentUserRole, roleScope: "PrepaidPlus" },
        ...prevRoles,
      ]);
    }

    if (
      currentBranch &&
      !branches.some((branch) => branch.branch === currentBranch)
    ) {
      branches.unshift({ branch: currentBranch });
    }

    setFormValues({
      firstName: user.firstName || "",
      lastName: user.lastName || "",
      role: user.role || "",
      branch: user.branch || ""
    });
  }, [user, userRoles.length, branches.length]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    if (!formValues.firstName || !formValues.lastName || !formValues.role || !formValues.branch) {
      setErrors({ form: "All fields are required." });
      return;
    }

    setErrors({});
    updateUserDetails(user.uid, formValues);
  };

  const updateUserDetails = async (uid, updatedValues) => {
    try {
      await firebase.firestore().collection('users').doc(uid).update({
        firstName: updatedValues.firstName,
        lastName: updatedValues.lastName,
        role: updatedValues.role,
        branch: updatedValues.branch,
        displayName: `${updatedValues.firstName} ${updatedValues.lastName}`
      });

      toastr.success("Success", "User details updated successfully.");

      if (onSubmit) {
        onSubmit(updatedValues);

      }

    } catch (error) {
      setErrors({ update: "Error updating user details. Please try again." });
    }
  };

  return (
    <div className={"full-height sm-p-t-30"}>
      <div className={"d-flex justify-content-center flex-column full-height"}>
        <form className={"p-t-15"} onSubmit={handleFormSubmit } style={{ width: '100%' }}>
          <div className={"row"} style={{ marginBottom: '20px' }}>
            <div className={"col-md-6"}>
              <div className="form-group">
                <label style={{ display: 'block', marginBottom: '5px' }}>First Name</label>
                <input
                  type="text"
                  name="firstName"
                  value={formValues.firstName}
                  onChange={handleChange}
                  placeholder="First Name"
                  className={"form-control"}
                  required
                  style={{ width: '100%', padding: '8px' }}
                />
                {errors.firstName && <small className="text-danger">{errors.firstName}</small>}
              </div>
            </div>

            <div className={"col-md-6"}>
              <div className="form-group">
                <label style={{ display: 'block', marginBottom: '5px' }}>Last Name</label>
                <input
                  type="text"
                  name="lastName"
                  value={formValues.lastName}
                  onChange={handleChange}
                  placeholder="Last Name"
                  className={"form-control"}
                  required
                  style={{ width: '100%', padding: '8px' }}
                />
                {errors.lastName && <small className="text-danger">{errors.lastName}</small>}
              </div>
            </div>
          </div>

          <div className={"row"} style={{ marginBottom: '20px' }}>
            <div className={"col-md-6"}>
              <div className="form-group">
                <label style={{ display: 'block', marginBottom: '5px' }}>User Role</label>
                <select
                  name="role"
                  value={formValues.role}
                  onChange={handleChange}
                  className={"form-control"}
                  required
                  style={{ width: '100%', padding: '8px' }}
                >
                  <option value="">Select Role...</option>
                  {userRoles.map((role, index) => (
                    <option key={index} value={role.role}>
                      {role.role}
                    </option>
                  ))}
                </select>
                {errors.role && <small className="text-danger">{errors.role}</small>}
              </div>
            </div>

            <div className={"col-md-6"}>
              <div className="form-group">
                <label style={{ display: 'block', marginBottom: '5px' }}>Branch</label>
                <select
                  name="branch"
                  value={formValues.branch}
                  onChange={handleChange}
                  className={"form-control"}
                  required
                  style={{ width: '100%', padding: '8px' }}
                >
                  <option value="">Select Branch...</option>
                  {branches.map((branch, index) => (
                    <option key={index} value={branch.branch}>
                      {branch.branch}
                    </option>
                  ))}
                </select>
                {errors.branch && <small className="text-danger">{errors.branch}</small>}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              {error && <label className={"error semi-bold"}>{error}</label>}
              {errors.form && <label className={"error semi-bold"}>{errors.form}</label>}
              <button 
                className={styles.btn} 
                type="submit" 
                disabled={loading}
                style={{ width: '100%', marginTop: '10px' }}
              >
                {loading ? (
                  <Spinner style={{ width: "20px", height: "20px", verticalAlign: "middle" }} />
                ) : (
                  <span>Edit User</span>
                )}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditSystemUserForm;
